"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAvatarEditor = _interopRequireDefault(require("react-avatar-editor"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactIntl = require("react-intl");

var _EditorControls = _interopRequireDefault(require("./EditorControls"));

var _ImageEditor = _interopRequireDefault(require("../../../blocks/ImageEditor"));

var _Button = _interopRequireDefault(require("../../../elements/Button"));

var _RangeSelector = _interopRequireDefault(require("../../../elements/RangeSelector"));

var _FormLabel = _interopRequireDefault(require("../../../elements/FormLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const FullWdith = _styledComponents.default.div.withConfig({
  displayName: "FullWdith"
})(["width:100%;"]);

class EditImage extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "editorRef", _react.default.createRef());

    _defineProperty(this, "state", {
      avatar: {
        scale: 1
      }
    });

    _defineProperty(this, "_handleScale", e => {
      const scale = parseFloat(e.target.value);
      this.setState(prevState => ({
        avatar: _objectSpread({}, prevState.avatar, {
          scale
        })
      }));
    });

    _defineProperty(this, "_handcleCancel", e => {
      e.preventDefault();
      const _cancelHandler = this.props._cancelHandler;

      _cancelHandler(null);
    });

    _defineProperty(this, "_handleSubmit", e => {
      e.preventDefault();
      const _submitHandler = this.props._submitHandler;

      if (this.editorRef) {
        const canvas = this.editorRef.current.getImage();
        const imgData = canvas.toDataURL('image/jpeg', 1.0);

        _submitHandler(imgData);
      }
    });
  }

  render() {
    const _this$props = this.props,
          imgFile = _this$props.imgFile,
          size = _this$props.size;
    const avatar = this.state.avatar;
    return /*#__PURE__*/_react.default.createElement(_ImageEditor.default, null, /*#__PURE__*/_react.default.createElement(_ImageEditor.default.Image, null, /*#__PURE__*/_react.default.createElement(_reactAvatarEditor.default, {
      ref: this.editorRef,
      image: imgFile,
      width: size,
      height: size,
      border: 0,
      borderRadius: size / 2,
      color: [0, 0, 0, 0.45],
      scale: parseFloat(avatar.scale)
    })), /*#__PURE__*/_react.default.createElement(_EditorControls.default, null, /*#__PURE__*/_react.default.createElement(FullWdith, null, /*#__PURE__*/_react.default.createElement(_FormLabel.default, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "EditImage.zoomLabel",
      defaultMessage: "Zoom:"
    }), /*#__PURE__*/_react.default.createElement(_RangeSelector.default, {
      onChange: this._handleScale,
      min: "1",
      max: "2",
      step: "0.01",
      defaultValue: "1"
    })))), /*#__PURE__*/_react.default.createElement(_EditorControls.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      modifiers: ['small'],
      onClick: this._handcleCancel
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "EditImage.cancelBtn",
      defaultMessage: "Cancel"
    })), /*#__PURE__*/_react.default.createElement(_Button.default, {
      modifiers: ['primary', 'small'],
      onClick: this._handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "EditImage.saveBtn",
      defaultMessage: "Save"
    }))));
  }

}

EditImage.propTypes = {
  _cancelHandler: _propTypes.default.func.isRequired,
  _submitHandler: _propTypes.default.func.isRequired,
  imgFile: _propTypes.default.shape({}).isRequired,
  size: _propTypes.default.number.isRequired
};
var _default = EditImage;
exports.default = _default;